/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { MenuItem, styled } from "@mui/material"

export const StyledMenuItem = styled(MenuItem)({
   fontSize: "0.875rem",
})
